import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper from '@styles/colors';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { ImageUpload } from '@helpers';
import { ICON_BUTTON_PADDING } from '@v2/pages/common/constants/base.constants';
import { ColorFunction } from '@styles/colors/types';
import { scale as initialScale } from '@components/frame';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { useNavigation } from '@react-navigation/native';
import { OP_DOCUMENTS_DISPLAY_MODE } from '@components/operatorPanel/constants/operatorPanel.constants';
import { ImageContextForAdding } from '@v2/components/imageHandling/types/types.d';

interface OperatorPanelInformationAllDocumentsActionsProps {
  C: ColorFunction;
  scale?: ScaleFunction;
  imageContextForAdding: ImageContextForAdding;
  amountOfImages: number;
  onSuccessImageUpload: () => void;
}

const OperatorPanelInformationAllDocumentsActions: FC<OperatorPanelInformationAllDocumentsActionsProps> = ({
  C,
  imageContextForAdding,
  amountOfImages,
  onSuccessImageUpload,
  scale = initialScale,
}) => {
  const navigation = useNavigation<any>();

  return (
    <>
      <TouchableElement
        onPress={() =>
          ImageUpload({
            ...imageContextForAdding,
            onSuccessImageUpload,
            saveToMainStore: true,
          })
        }
      >
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              boxStyle,
              {
                backgroundColor: C(pressHoverColor('Button/Light/Only Text')),
                padding: scale(ICON_BUTTON_PADDING),
                borderRadius: scale(18),
              },
            ]}
          >
            <Svg icon="plus" width={scale(20)} height={scale(20)} color="Button/Light/Primary" />
          </View>
        )}
      </TouchableElement>
      {amountOfImages > 1 && (
        <TouchableElement onPress={() => navigation.setParams({ mode: OP_DOCUMENTS_DISPLAY_MODE.GALLERY })}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  backgroundColor: C(pressHoverColor('Button/Light/Only Text')),
                  padding: scale(ICON_BUTTON_PADDING),
                  paddingVertical: scale(ICON_BUTTON_PADDING + 3),
                  borderRadius: scale(24),
                },
              ]}
            >
              <Svg icon="gallery" width={scale(24)} height={scale(19)} color="Button/Light/Primary" />
            </View>
          )}
        </TouchableElement>
      )}
    </>
  );
};

export default ColorWrapper(OperatorPanelInformationAllDocumentsActions);
